module.exports = {
  defaultTitle: 'Yway Chit Aung',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'Yway Chit Aung',
  url: 'https://portfolio.smakosh.com',
  legalName: 'Yway Chit Aung',
  defaultDescription: 'I’m John and I’m a Backend & Devops engineer!',
  socialLinks: {
    twitter: 'https://twitter.com/ywaychitaung',
    github: 'https://github.com/ywaychitaung',
    linkedin: 'https://www.linkedin.com/in/ismail-ghallou-630149122/',
    instagram: 'https://instagram.com/smakosh19',
    youtube: 'https://www.youtube.com/user/smakoshthegamer',
    google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
  },
  googleAnalyticsID: 'UA-88875900-4',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@ywaychitaung',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2018',
};
